import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
  tooltipContent: {
    background: 'rgb(255, 255, 255, 0.8)',
    border: 1,
    padding: 2,
    fontSize: 14,
    width: 400,
    textAlign: 'left',
    paddingLeft: 20
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  headline: {
    color: 'pink'
  },
  headlineAsset: {
    color: 'lightgreen'
  },
  display1: {
    color: 'lightgrey',
    textAlign: 'left',
    padding: '30px'
  }
})

const axis = {
  orient: 'left',
  tickFormat: d => (
    <text
      key={`tick-${d}`}
      style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
      y={-2}
      x={6}
    >
      {d / 1000}K
    </text>
  ),
  tickValues: [0, 500, 1000, 1500, 2000],
  baseline: false,
  tickLineGenerator: ({ xy }) => (
    <path
      key={`tickLine-${xy.value}`}
      style={{ stroke: '#F0F0F0 ' }}
      d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${xy.y1}L${xy.x1},${
        xy.y1
      }Z`}
    />
  )
}

@withStyles(styles)
export default class FinaChartSpentOtherCost extends Component {
  render() {
    const { classes } = this.props
    const data = this.props.chart
      ? JSON.parse(this.props.chart.dataSetNew.dataPoints)
      : JSON.parse(this.props.data)

    return (
      <OrdinalFrame
        size={[this.props.width, this.props.height]}
        data={data}
        axis={axis}
        rExtent={[0, undefined]}
        oExtent={{
          onChange: d => {
            this.setState({ oExtent: d })
          }
        }}
        projection={'vertical'}
        type={{
          type: 'bar',
          customMark: d => (
            <rect
              key={`mark-${d.renderKey}`}
              fill={
                d.SpendType === 'Movie/TV'
                  ? 'pink'
                  : d.SpendType === 'Gas'
                    ? 'orange'
                    : d.SpendType === 'Car'
                      ? 'blue'
                      : d.SpendType === 'CarWash'
                        ? 'blue'
                        : d.SpendType === 'CarFastrak'
                          ? 'blue'
                          : d.SpendType === 'Parking'
                            ? 'blue'
                            : d.SpendType === 'Public Transportation'
                              ? 'lightblue'
                              : d.SpendType === 'Taxi'
                                ? 'lightblue'
                                : d.SpendType === 'Bank Fee'
                                  ? 'yellow'
                                  : d.SpendType === 'Utility'
                                    ? 'orange'
                                    : d.SpendType === 'Travel'
                                      ? 'purple'
                                      : d.SpendType === 'Outing'
                                        ? 'purple'
                                        : d.SpendType === 'Outdoor'
                                          ? 'purple'
                                          : d.SpendType === 'HealthCare'
                                            ? 'green'
                                            : d.SpendType === 'DocFee'
                                              ? 'green'
                                              : d.SpendType === '?'
                                                ? 'red'
                                                : 'grey'
              }
              opacity={0.5}
              width={
                this.props.width *
                (1 - 1 / 15.5 - 1 / 12.6 - 6 / 22 - 1 / 30) /
                7
              }
              height={d.scaledValue}
              rx={2}
              ry={2}
            />
          )
        }}
        oLabel={d =>
          d === moment().format('MMM YY') ? (
            <text
              key={`label-${d}`}
              y={2}
              fill="#62c71f"
              textAnchor="middle"
              fontSize={12}
            >
              {d}
            </text>
          ) : (
            <text
              key={`label-${d}`}
              y={2}
              fill="#9BA4A5"
              textAnchor="middle"
              fontSize={12}
            >
              {d}
            </text>
          )
        }
        oPadding={this.props.width / 22}
        oAccessor={d => moment(new Date(d.Date)).format('MMM YY')}
        rAccessor={d => d.AmountC}
        sortO={(a, b) => a < b}
        style={d => {
          return { fill: 'green' }
        }}
        hoverAnnotation={true}
        annotationSettings={{
          layout: {
            type: 'marginalia',
            orient: 'right',
            textPadding: this.props.width / 21
          }
        }}
        margin={{
          left: this.props.width / 15.5,
          top: this.props.height / 24,
          right: this.props.width / 12.6,
          bottom: this.props.height / 9.6
        }}
        tooltipContent={d => {
          let total = 0
          d.pieces.forEach(p => {
            total = total + parseFloat(p.AmountC)
          })
          return (
            <div key={`tooltip-${d.pieces[0].renderKey}`}>
              <div
                className={classes.tooltipContent}
                key={`tooltip${d.pieces[0].renderKey}`}
              >
                <b>
                  {moment(new Date(d.pieces[0].Date)).format('MMM YY')} Total:{' '}
                  {total.toFixed(0)}{' '}
                </b>
                <br />
              </div>
              {d.pieces.map((piece, index) => (
                <div
                  className={classes.tooltipContent}
                  key={`item-${piece.Description}`}
                >
                  <span
                    style={{
                      color:
                        piece.SpendType === 'Movie/TV'
                          ? 'pink'
                          : piece.SpendType === 'Gas'
                            ? 'orange'
                            : piece.SpendType === 'Car'
                              ? 'blue'
                              : piece.SpendType === 'CarWash'
                                ? 'blue'
                                : piece.SpendType === 'CarFastrak'
                                  ? 'blue'
                                  : piece.SpendType === 'Parking'
                                    ? 'blue'
                                    : piece.SpendType ===
                                      'Public Transportation'
                                      ? 'lightblue'
                                      : piece.SpendType === 'Taxi'
                                        ? 'lightblue'
                                        : piece.SpendType === 'Bank Fee'
                                          ? 'yellow'
                                          : piece.SpendType === 'Utility'
                                            ? 'orange'
                                            : piece.SpendType === 'Travel'
                                              ? 'purple'
                                              : piece.SpendType === 'Outing'
                                                ? 'purple'
                                                : piece.SpendType === 'Outdoor'
                                                  ? 'purple'
                                                  : piece.SpendType ===
                                                    'HealthCare'
                                                    ? 'green'
                                                    : piece.SpendType ===
                                                      'DocFee'
                                                      ? 'green'
                                                      : piece.SpendType === '?'
                                                        ? 'red'
                                                        : 'grey'
                    }}
                  >
                    {piece.SpendType}
                  </span>: {parseFloat(piece.AmountC).toFixed(0)}{' '}
                  <span style={{ fontSize: 12, color: 'lightgrey' }}>
                    ({piece.Description})
                  </span>
                </div>
              ))}
            </div>
          )
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/FinaChartSpentOtherCost.js